module.exports = "../images/bear-hunting.jpg?v=d5ab4ae";